import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class SocialMediaLinks extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            links: ['.m-socialMediaLinks__socialLink'],
        };
    }

    getPropsFromDom() {
        const props = [];

        for (let i = 0; i < this.dom.links.length; i += 1) {
            const type = this.dom.links[i].getAttribute('data-type');
            props.push({ [type]: true, link: this.dom.links[i].href });
        }

        return props;
    }
}
